import { LitElement, html, css, type TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";

declare global {
  interface HTMLElementTagNameMap {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    "web-kiosk-home-link": WebKioskHomeLinkElement;
  }
}

@localized()
@customElement("web-kiosk-home-link")
export class WebKioskHomeLinkElement extends LitElement {
  @property({ type: String }) link = "home";

  render(): TemplateResult {
    return html`<a class="home-link" href=${this.link}>
      <img
        src="assets/shared/home-logo.svg"
        alt=${msg("Walgreens Logo", { id: "walgreens-logo" })}
      />
      ${msg("Home", {
        id: "home-link",
        desc: "Click to return back to the main page of the application",
      })}
    </a>`;
  }

  static styles = css`
    :host {
      --web-kiosk-link-color: #284b9b;

      display: flex;
    }

    .home-link {
      color: var(--web-kiosk-link-color, hotpink);
    }

    .home-link img {
      margin-right: 8px;
    }

    a {
      display: inline-flex;
      align-items: center;
      text-decoration: none;
      font-size: 33px;
      font-weight: 700;
      line-height: 40px;
      color: var(--web-kiosk-link-color, hotpink);
    }
  `;
}
